import { useSelector } from 'react-redux';
import { useApplicationContext } from '../../utils/applicationContext';
import { selectBuilderId } from '../../selectors/builder';
import { ReliableBlock } from '../../components/ReliableBlock';
import { trackButtonClick } from './tracking';
import * as React from 'react';

export const ReliableBlockContainer = () => {
  const { config } = useApplicationContext();
  const builderId = useSelector(selectBuilderId);

  const reliableBuilders = config.get<number[]>('countryside.reliableBuilders');

  if (!reliableBuilders?.includes(builderId)) {
    return null;
  }

  return <ReliableBlock onClick={trackButtonClick} />;
};
